import WalkInSVG from "@design-system/ui-icons/vanilla/WalkIn"
import { createIcon } from "../createIcon"

export const WalkInIcon = createIcon(WalkInSVG)
